import { FormEventHandler, useMemo } from 'react';

import { usePasswordRecovery } from '~/modules/auth/hooks/usePasswordRecovery';

import { Collapse } from '~/shared/components/Collapse';
import { Button } from '~/shared/components/Button';

import { FCWithChildren } from '~/shared/types/FCWithChildren';

import { Container } from './styles';

interface IStepWrapperProps {
  step: number;
  onSubmit(): void | Promise<void>;
  isSubmitting?: boolean;
}

export const StepWrapper: FCWithChildren<IStepWrapperProps> = ({
  children,
  step,
  onSubmit = () => null,
  isSubmitting = false,
}) => {
  const { currentStep } = usePasswordRecovery();

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    onSubmit?.();
  };

  const submitButtonTitle = useMemo(() => {
    return {
      1: 'Continuar',
      2: 'Recuperar',
      3: 'Continuar',
      4: 'Redefinir',
    }[currentStep];
  }, [currentStep]);

  return (
    <Container onSubmit={handleSubmit} currentStep={currentStep} step={step}>
      <Collapse isOpen={currentStep === step} startingHeight={100}>
        {children}

        <Button type="submit" mt="md" size="lg" isLoading={isSubmitting}>
          {submitButtonTitle}
        </Button>
      </Collapse>
    </Container>
  );
};
